export default __webpack_public_path__ + "fonts/ob_4.ee9510e2822e6e69ee4b180d9ce12211.png";